export default __webpack_public_path__ + "static/media/blog3.08155c29.jpg";